import { render, staticRenderFns } from "./environmentForm.vue?vue&type=template&id=2945178e"
import script from "./environmentForm.vue?vue&type=script&lang=js"
export * from "./environmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports